(function () {
  const SLIDE_SELECTOR = '.arn-gallery-slide[data-media-ready]';
  const FALLBACK_MS = 15000;

  const watched = new WeakSet();

  const resolveImage = (slide) => slide.querySelector('img');

  const markReady = (slide) => {
    if (!slide || !slide.isConnected) return;
    if (slide.dataset.mediaReady === 'true') return;
    slide.dataset.mediaReady = 'true';
  };

  const watchSlide = (slide) => {
    let mutationObs = null;
    let fallback = null;

    const cleanup = () => {
      if (mutationObs) { mutationObs.disconnect(); mutationObs = null; }
      if (fallback)   { clearTimeout(fallback);   fallback = null; }
    };

    const observeImage = (img) => {
      if (!img) return false;
      if (img.complete && img.naturalWidth > 0) {
        markReady(slide);
        return true;
      }
      const onReady = () => { markReady(slide); cleanup(); };
      img.addEventListener('load',  onReady, { once: true });
      img.addEventListener('error', onReady, { once: true });
      return true;
    };

    if (observeImage(resolveImage(slide))) {
      cleanup();
      return;
    }

    mutationObs = new MutationObserver(() => {
      if (slide.dataset.mediaReady === 'true') { cleanup(); return; }
      if (observeImage(resolveImage(slide))) cleanup();
    });
    mutationObs.observe(slide, { childList: true, subtree: true });

    fallback = window.setTimeout(() => { markReady(slide); cleanup(); }, FALLBACK_MS);
  };

  const observeSlide = (slide) => {
    if (!slide || watched.has(slide)) return;
    if (slide.dataset.mediaReady !== 'false') return;
    watched.add(slide);
    watchSlide(slide);
  };

  const hydrate = (root) => {
    if (!root) return;
    if (root.matches?.(SLIDE_SELECTOR)) observeSlide(root);
    root.querySelectorAll?.(SLIDE_SELECTOR).forEach(observeSlide);
  };

  const start = () => {
    hydrate(document);
    const rootObs = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === Node.ELEMENT_NODE) hydrate(n);
        });
      });
    });
    if (document.body) rootObs.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
